/**
 * @generated SignedSource<<3f7389e902fa397d31ba9a2589e04362>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type PostStatusEnum = "acfDisabled" | "archived" | "autoDraft" | "dpRewriteRepublish" | "draft" | "future" | "inherit" | "pending" | "private" | "publish" | "requestCompleted" | "requestConfirmed" | "requestFailed" | "requestPending" | "trash" | "%future added value";
export type PostTemplateEnum = "brandedFullWidth" | "brandedPortrait" | "fullWidth" | "specialFeatureFullWidth" | "specialFeatureOverlay" | "specialFeatureSquare" | "square" | "%future added value";
export type ResourceTypeEnum = "authorProfile" | "campaign" | "category" | "clientError" | "customStory" | "diningReport" | "embedStory" | "homepage" | "image" | "internalCategory" | "internalSuperCat" | "linkPost" | "loopNav" | "map" | "mmaEvent" | "mmaFight" | "mmaFighter" | "mmaPromotion" | "mmaWeightClass" | "neighborhood" | "package" | "page" | "post" | "product" | "productBrand" | "quickPost" | "redirect" | "series" | "startHere" | "stream" | "superCat" | "tag" | "vault" | "venue" | "videoGame" | "videoGamePlatform" | "videoPost" | "volumeVideo" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ParselyTagsContainer_feedContentResource$data = {
  readonly authors?: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
  }>;
  readonly categories?: ReadonlyArray<{
    readonly slug: string;
  }>;
  readonly chorusId: number | null;
  readonly featuredImage: {
    readonly image: {
      readonly thumbnails: {
        readonly social: {
          readonly url: string;
        };
      };
    };
  } | null;
  readonly games?: {
    readonly nodes: ReadonlyArray<{
      readonly title: string;
    }>;
  } | null;
  readonly id: string;
  readonly internalCategories?: ReadonlyArray<{
    readonly slug: string;
  }>;
  readonly internalSuperCats?: ReadonlyArray<{
    readonly slug: string;
  }>;
  readonly ledeMedia: {
    readonly __typename: "LedeMediaImageType";
    readonly image: {
      readonly thumbnails: {
        readonly social: {
          readonly url: string;
        };
      };
    };
  } | {
    readonly __typename: "LedeMediaVideoType";
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
  readonly originalPublishedAt: string | null;
  readonly package?: {
    readonly chorusId: number | null;
    readonly id: string;
  } | null;
  readonly permalink: string;
  readonly primaryCategory?: {
    readonly slug: string;
    readonly title: string;
  };
  readonly resourceType: ResourceTypeEnum;
  readonly social: {
    readonly image: {
      readonly thumbnails: {
        readonly social: {
          readonly url: string;
        };
      };
    } | null;
  };
  readonly status: PostStatusEnum;
  readonly streams?: {
    readonly nodes: ReadonlyArray<{
      readonly chorusId: number | null;
      readonly id: string;
    }>;
  } | null;
  readonly superCats?: ReadonlyArray<{
    readonly slug: string;
  }>;
  readonly template?: PostTemplateEnum | null;
  readonly title: string;
  readonly " $fragmentType": "ParselyTagsContainer_feedContentResource";
};
export type ParselyTagsContainer_feedContentResource$key = {
  readonly " $data"?: ParselyTagsContainer_feedContentResource$data;
  readonly " $fragmentSpreads": FragmentRefs<"ParselyTagsContainer_feedContentResource">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "chorusId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v4 = [
  (v3/*:: as any*/)
],
v5 = [
  (v1/*:: as any*/),
  (v2/*:: as any*/)
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "ImageResourceType",
  "kind": "LinkedField",
  "name": "image",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ThumbnailMapType",
      "kind": "LinkedField",
      "name": "thumbnails",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ThumbnailType",
          "kind": "LinkedField",
          "name": "social",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v8 = [
  (v7/*:: as any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ParselyTagsContainer_feedContentResource",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    (v0/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "permalink",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "resourceType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "originalPublishedAt",
      "storageKey": null
    },
    (v1/*:: as any*/),
    (v2/*:: as any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CategoryResourceType",
          "kind": "LinkedField",
          "name": "primaryCategory",
          "plural": false,
          "selections": [
            (v0/*:: as any*/),
            (v3/*:: as any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "InternalSuperCatResourceType",
          "kind": "LinkedField",
          "name": "internalSuperCats",
          "plural": true,
          "selections": (v4/*:: as any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SuperCatResourceType",
          "kind": "LinkedField",
          "name": "superCats",
          "plural": true,
          "selections": (v4/*:: as any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "InternalCategoryResourceType",
          "kind": "LinkedField",
          "name": "internalCategories",
          "plural": true,
          "selections": (v4/*:: as any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CategoryResourceType",
          "kind": "LinkedField",
          "name": "categories",
          "plural": true,
          "selections": (v4/*:: as any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PackageResourceType",
          "kind": "LinkedField",
          "name": "package",
          "plural": false,
          "selections": (v5/*:: as any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 100
            }
          ],
          "concreteType": "FeedContentStreamsConnection",
          "kind": "LinkedField",
          "name": "streams",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "StreamResourceType",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": (v5/*:: as any*/),
              "storageKey": null
            }
          ],
          "storageKey": "streams(first:100)"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AuthorProfileResourceType",
          "kind": "LinkedField",
          "name": "authors",
          "plural": true,
          "selections": [
            (v2/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "FeedContentResourceInterfaceVideoGamesConnection",
          "kind": "LinkedField",
          "name": "games",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "VideoGameResourceType",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                (v0/*:: as any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "FeedContentResourceInterface",
      "abstractKey": "__isFeedContentResourceInterface"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "ledeMedia",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            (v6/*:: as any*/),
            (v7/*:: as any*/)
          ],
          "type": "LedeMediaImageType",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v6/*:: as any*/)
          ],
          "type": "LedeMediaVideoType",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ShareableDataType",
      "kind": "LinkedField",
      "name": "social",
      "plural": false,
      "selections": (v8/*:: as any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FeaturedImageType",
      "kind": "LinkedField",
      "name": "featuredImage",
      "plural": false,
      "selections": (v8/*:: as any*/),
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "template",
          "storageKey": null
        }
      ],
      "type": "PostResourceType",
      "abstractKey": null
    }
  ],
  "type": "ContentResourceInterface",
  "abstractKey": "__isContentResourceInterface"
};
})();

(node as any).hash = "b3758f3e0faff7d7b919edab37beedd5";

export default node;
